import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { FormInput } from "../FormElements";
import { CommonFieldsRefProp, CommonPaymentFields, PaymentProviderListType, PaymentProviderParamsType } from "../../../common/types";
import commonNetwork from "../../../common/api/commonNetwork";
import paymentApi from "../../../common/api/paymentApi";
import { RootStateType } from "../../../store/RootState";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import InstallmentList from "./InstallmentList";
import PaymentProviders from "./PaymentProviders";
import { useFormikContext } from "formik";
import { Button } from "../Elements";
import InstallmentHtmlTable, { InstallmentHtmlTableRefProps } from "../InstallmentHtmlTable";
import AmountInput from "./AmountInput";
import { InstallmentListType, PaymentContractInformations } from "../../../common/types/PaymentTypes";
import FirmContractList from "./FirmContractList";


interface Props extends CommonPaymentFields {
    amount: string,
    isPaymentProviderSelect: boolean,
    paymentAmount: string,
    setPaymentAmount: (value: string) => void,
    setDisablePost: (value: boolean) => void,
    amountSelectType: "manuel" | "auto",
    customerId?: number,
    fromPage: "portal" | "paymentLink" | "publicPayment",
    licenseKey: string,
    taxCode: string,
    isEditAmount: boolean,
    initialPaymentProvider?: number,
    initialInstallmentList?: Array<InstallmentListType>,
    contractList: Array<PaymentContractInformations>
}

const paymentProviderInitialParams: PaymentProviderParamsType = {
    manufacturerCard: "false",
    paymentProvider: 0,
}

const CommonFields = React.forwardRef<CommonFieldsRefProp, Props>((props: Props, ref) => {

    const formikProps = useFormikContext()



    useImperativeHandle(ref, () => ({

        selectInstallments() {
            selectInstallmentList();
        },
        getSelectedPaymentProvider(): PaymentProviderParamsType {
            return paymentProviderParams;
        },
    }));

    const installmentHtmlTableRef = useRef<InstallmentHtmlTableRefProps>(null);
    const [paymentProviderParams, setPaymentProviderParams] = useState(paymentProviderInitialParams);

    const [installmentLoading, setInstallmentLoading] = useState(false);
    const [installmentList, setInstallmentList] = useState([]);
    const [paymentProviderList, setPaymentProviderList] = useState<Array<PaymentProviderListType>>([]);
    const [selectedInstallment, setSelectedInstallment] = useState(1);

    const [installmentLimitError, setInstallmentLimitError] = useState("");

    const { amount, paymentProviderId, termAndConditionCheck,
        cardHolderName, cardNumber, cvc, isPaymentProviderSelect, paymentDesc,
        paymentAmount, setPaymentAmount, setDisablePost, amountSelectType, customerId,
        licenseKey, taxCode, fromPage, isEditAmount, expireDate, initialInstallmentList, initialPaymentProvider,
        contractList} = props;

    const parsedAmount = (amount + "").replaceAll(".", "").replaceAll(",", "");

    useEffect(() => {

        selectPaymentProviders();

    }, []);
    useEffect(() => {

        if (cardNumber?.length > 18 && parseInt(parsedAmount) > 0) {
            selectInstallmentList();
        }

    }, [cardNumber, amount, paymentProviderParams.paymentProvider]);

    const selectPaymentProviders = async () => {

        const method = `posintegration/all-from-web`;
        const apiParams = { licenseKey: licenseKey, taxCode: taxCode };

        const { data, errorMessage, isSuccess } = await paymentApi.get(method, null, apiParams);


        if (isSuccess) {
            setPaymentProviderList(data);
        }
    }

    const openHtmlTableModal = () => {
 
        installmentHtmlTableRef.current?.openModal(amount);
    }

    const selectInstallmentList = async () => {

        if (!(initialPaymentProvider && initialPaymentProvider > 0)) {
            setDisablePost(true);
            setInstallmentLoading(true);
            const params = {
                CardNumber: cardNumber,
                Amount: (amount + "").replaceAll(".", "").replaceAll(",", ""),
                PaymentProviderId: paymentProviderParams.paymentProvider || 0
            }
            const apiParams = { licenseKey: licenseKey, taxCode: taxCode };
            const { data, errorMessage, isSuccess } = await paymentApi.get("/installments", params, apiParams);
            setInstallmentLoading(false);
            setDisablePost(false);


            if (isSuccess) {

                if (data.minAmountAlert || data.maxAmountAlert) {
                    setInstallmentList([]);
                    setInstallmentLimitError(data.minAmountAlert || data.maxAmountAlert);
                } else {
                    setInstallmentLimitError("");
                    setInstallmentList(data.installmentList);
                    setPaymentProviderParams({
                        ...paymentProviderParams,
                        paymentProvider: data.vpId,
                        ...data
                    });
                    formikProps.setFieldValue("paymentProviderId", data.vpId);
                    setPaymentAmount(data.amount);
                }


            } else {
                setInstallmentList([]);
                toast.error(errorMessage);
            }
        }
    }
    const onInstallmentItem =(item : InstallmentListType)=>{

        setSelectedInstallment(item.month);
        setPaymentAmount(item.totalAmount);
    }



    return (
        <div >
            <div className="flex flex-row justify-start">
                <span className="font-bold text-contrast-90 text-xl px-2">
                    Ödeme bilgileri
                </span>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-4 xl:grid-cols-4 mt-3">
                <div className="col-span-2 mt-3 space-y-2">

                    <label className="block text-contrast-70 whitespace-nowrap">
                        Ödeme Tutarı
                    </label>
                    <AmountInput amount={amount} hideAmountSelect={props.fromPage != "portal"}
                        isEditAmount={isEditAmount}
                        amountSelectType={props.fromPage == "portal" ? amountSelectType : "manuel"} customerId={customerId} />


                    <FormInput
                        label="Açıklama"
                        name="paymentDesc"
                        required
                        type="text"
                        value={paymentDesc}
                    />
                </div>

                <InstallmentHtmlTable hideAmountInput licenseKey={licenseKey} taxCode={taxCode} ref={installmentHtmlTableRef} />


            </div>

            {initialPaymentProvider && initialPaymentProvider > 0 ? null : (
                <div className="my-4">
                    <Button size="xl" color="primary" callback={openHtmlTableModal} type="button">
                        Tüm Taksit Seçeneklerini Görüntüle
                    </Button>
                </div>
            )}


            <span className="font-bold text-contrast-90 text-xl px-2">
                Kart bilgileri
            </span>
            <FormInput
                label="Adı Soyadı"
                placeholder=""
                name="cardHolderName"
                required
                type="text"
            />
            <FormInput
                label="Kart Numarası"
                placeholder="**** **** **** ****"
                mask={"9999 9999 9999 9999"}
                name="cardNumber"
                required
                type="text"
            />

            <FormInput
                label="Son Kullanım Tarihi"
                mask={"99/99"}
                name="expireDate"
                required
                type="text"
            />
            <FormInput
                label="Cvc"
                name="cvc"
                required
                type="text"
            />
            <div className="mt-5 px-5 py-5">
                {fromPage == "portal" && (
                    <PaymentProviders paymentProviders={paymentProviderList}
                        selectedPaymentProvider={paymentProviderParams.paymentProvider}
                        disabled={installmentLoading}
                        setSelected={(val: number) => {
                            setPaymentProviderParams({
                                ...paymentProviderParams,
                                paymentProvider: val
                            });
                        }}
                    />

                )}

            </div>
            <div className="mt-5 px-5 py-5">
                <InstallmentList 
                installmentList={(initialPaymentProvider && initialPaymentProvider > 0) ? initialInstallmentList : installmentList} 
                selectedInstallment={selectedInstallment}
                    setSelected={(item)=>onInstallmentItem(item)} loading={installmentLoading} />
            </div>

            
            <FirmContractList contractList={contractList}/>
        </div>
    );
})
export default CommonFields;